module.exports = __webpack_public_path__ + "img/asb-full-logo-without-text.51337032.png";